module.exports = {
      id: "colored-logo-usage",
      viewBox: "0 0 562.678 45.31",
      url: __webpack_public_path__ + "assets/sprite-28816f.svg#colored-logo-usage",
      toString: function () {
        return this.url;
      }
    }